module.exports = __webpack_public_path__ + "img/Asian_Quinoa_Bowl_Chicken.b9c3fea5.jpg";